if (!window.reaCartBundleBreakdownInit) {
  window.reaCartBundleBreakdownInit = true;

  // Reads every dropdown currently in this breakdown panel, plus the
  // bundle's own currently-selected options for any option that has no
  // dropdown (a single-value option with nothing to choose), and returns
  // the full target combination in the bundle's own option order - not
  // just the one dropdown that changed, since Shopify variants are
  // addressed by their complete option combination.
  function buildTargetValues(container) {
    const bundleOptionNames = JSON.parse(container.dataset.bundleOptions || '[]');
    const currentOptions = JSON.parse(container.dataset.currentOptions || '[]');
    const selects = Array.from(container.querySelectorAll('[data-bundle-breakdown-select]'));

    return bundleOptionNames.map((name) => {
      const select = selects.find((s) => s.dataset.optionName === name);
      if (select) return select.value;
      const current = currentOptions.find((o) => o.name === name);
      return current ? current.value : null;
    });
  }

  async function handleChange(select) {
    const container = select.closest('[data-bundle-breakdown]');
    if (!container) return;

    const targetValues = buildTargetValues(container);
    if (targetValues.some((v) => v == null)) {
      // A bundle option had neither a dropdown nor a known current value -
      // a real data mismatch, not something to guess past.
      console.error('[rea-cart-bundle-breakdown] incomplete option combination, aborting', targetValues);
      return;
    }

    const bundleVariants = JSON.parse(container.dataset.bundleVariants || '[]');
    const newVariantId = window.reaFindBundleVariant(bundleVariants, targetValues);
    if (!newVariantId) {
      console.error('[rea-cart-bundle-breakdown] could not determine a variant for', targetValues);
      return;
    }

    const currentVariantId = Number(container.dataset.currentVariantId);
    if (newVariantId === currentVariantId) return; // selection didn't actually change the resulting variant

    const lineKey = container.dataset.lineKey;
    const quantityInput = document.querySelector(`[data-quantity-line-key="${lineKey}"]`);
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    container.classList.add('loading');
    container.querySelectorAll('select').forEach((s) => {
      s.disabled = true;
    });

    // A single /cart/update.js call, keyed by variant id (documented
    // Shopify Cart AJAX behavior - these lines have no custom properties,
    // so variant id addresses each line unambiguously): the old variant
    // goes to 0 and the new one gets the line's current quantity, applied
    // as one request rather than the swap feature's sequential add-then-
    // remove. This is editing the same bundle already in the cart, not
    // replacing a different product with it, so there's no "different
    // product, needs its own add" step the way the swap feature has one.
    try {
      const updates = {};
      updates[currentVariantId] = 0;
      updates[newVariantId] = quantity;

      const res = await fetch(routes.cart_update_url, {
        ...fetchConfig('json'),
        body: JSON.stringify({ updates }),
      });
      const cart = await res.json();
      if (cart.status || cart.errors) {
        throw new Error(cart.description || cart.message || JSON.stringify(cart.errors));
      }
    } catch (error) {
      // Shopify validates the whole updates object before applying it, so
      // a rejected request (e.g. the new variant is sold out) shouldn't
      // leave the cart half-changed - but the refresh below re-renders
      // from the actual server state regardless, so the UI can't drift
      // from reality even if that assumption ever turns out to be wrong.
      console.error('[rea-cart-bundle-breakdown] variant update failed', error);
    } finally {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-breakdown' });
    }
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-bundle-breakdown-select]');
    if (!select) return;
    handleChange(select);
  });
}
